<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('frunds')"
          :directory="[$t('frunds'), $t('frund')]"
          :icon="'users'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="text-sm-right mb-primary mb-sm-0 mb-md-0">
          <div class="dropdown d-inline-block btn-dropdown">
            <button
              type="button"
              class="btn btn-success dropdown-toggle ml-0 mr-2"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {{ $t("actions") }}
            </button>
            <div class="dropdown-menu">
              <a
                class="dropdown-item d-flex align-items-center p-3"
                :href="urlGenerator(`crm/frund/import`)"
              >
                <app-icon
                  stroke-width="1"
                  :name="'download'"
                  width="16"
                  height="16"
                  class="mr-3"
                />
                {{ $t("import_people") }}
              </a>
              <a
                class="dropdown-item d-flex align-items-center p-3"
                href=""
                @click.prevent="openContactModal()"
              >
                <app-icon
                  stroke-width="1"
                  :name="'plus-circle'"
                  width="16"
                  height="16"
                  class="mr-3"
                />
                {{ $t("add_leads_group") }}
              </a>
              <a
                class="dropdown-item d-flex align-items-center p-3"
                :href="urlGenerator(`crm/contact/type/list`)"
              >
                <app-icon
                  stroke-width="1"
                  :name="'settings'"
                  width="16"
                  height="16"
                  class="mr-3"
                />
                {{ $t("manage_lead_group") }}
              </a>
            </div>
          </div>
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openModal()"
          >
            {{ $t("add_frund") }}
          </button>
        </div>
      </div>
    </div>
    <app-table :id="tableId" :options="options" @action="getAction" />

    <app-frund-modal
      v-if="isFrundModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      @openOrgModal="openOrganizationModal"
      @close-modal="closeModal"
    />
    <app-contact-type-modal
      v-if="isContactModalActive"
      :table-id="contacttableId"
      @close-modal="closeContactModal"
    />
    <app-confirmation-modal
      v-if="confirmationModalActive"
      modal-id="frund-delete-modal"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />

    <app-organization-modal
      v-if="organizationModal"
      :table-id="'organization-modal'"
      @close-modal="closeOrgModal"
    />

    <app-frund-quick-view
      v-if="isQuickViewModalActive"
      dal-id="quickViewModal"
      :selected-url="selectedUrl"
      @openActivityModal="commonActivityModal"
      @viewAllDeal="openViewAllDeal"
      @viewAllFollower="openViewAllFollower"
      @editNote="editNote"
      @close-modal="closeQuickViewModal"
    />

    <app-common-activity-modal
      v-if="frundActivitiesModal"
      :activity="rowData"
      :selected-url="editedUrl"
      @close-modal="closeActivityModal"
    />

    <app-common-all-deals
      v-if="viewAllDeal"
      :id="frundId"
      :context-type="'frund'"
      :table-id="'details-view-modal'"
      @close-modal="closeViewAllModal"
    />
    <app-common-all-follower
      v-if="viewAllFollower"
      :follower-data="followerUrl"
      @close-modal="closedFollowerModal"
    />
    <app-common-note-modal
      v-if="isNoteModal"
      :note="noteRowData"
      @close-modal="closeNoteModal"
    />
  </div>
</template>
<script>
import CoreLibrary from "@core/helpers/CoreLibrary.js";
import { formatDateToLocal, collection, urlGenerator } from "@app/Helpers/helpers";
import { mapGetters } from "vuex";
import { owner, contactType, organization, tag } from "@app/Mixins/Global/FilterMixins";
import { getCustomFileds } from "@app/Mixins/Global/CustomFieldMixin";
import { DeleteMixin } from "@app/Mixins/Global/DeleteMixin";
export default {
  name: "Frund",
  extends: CoreLibrary,
  mixins: [owner, contactType, organization, tag, getCustomFileds, DeleteMixin],
  data() {
    return {
		formatDateToLocal,
      urlGenerator,
      isFrundModalActive: false,
      isContactModalActive: false,
      tableId: "frund-modal",
      contacttableId: "contact-modal",
      confirmationModalActive: false,
      isQuickViewModalActive: false,
      organizationModal: false,
      frundActivitiesModal: false,
      editedUrl: "",
      viewAllDeal: false,
      viewAllFollower: false,
      isNoteModal: false,
      noteRowData: null,
      frundId: null,
      selectedUrl: "",
      activityData: {},
      followerUrl: "",
      commonColumn: [
        
		{
          title: this.$t("id"),
          type: "text",
          key: "id",
        },
		  
		  {
          title: this.$t("lead_group"),
          type: "custom-html",
          key: "contact_type",
          modifier: (value, row) => {
            return value
              ? `<span class="badge badge-pill badge-${value.class ?? "secondary"}">${
                  value.name
                }</span>`
              : "-";
          },
        },
				
		{
          title: this.$t("title"),
          type: "link",
          key: "name",
          modifier: (value, row) => {
            return `crm/frunds/${row.id}/edit`;
          },
        },
		 
	   
				
		{
          title: this.$t("owner"),
          type: "object",
          key: "owner",
          modifier: (value, row) => {
            return value ? value.full_name : "";
          },
        },
		
		{
          title: this.$t("condi_frund"),
          type: "text",
          key: "cond",
        },
		
        
        
        
       {
          title: this.$t("date_buy_frund"),
          type: "custom-html",
          key: "date_buy",
          modifier: (value, row) => {
            return value
              ? `<span class="text-nowrap">${formatDateToLocal(row.date_buy)}</span>`
              : "-";
          },
        },
        
        {
          title: this.$t("tags"),
          type: "component",
          key: "tags",
          isVisible: true,
          componentName: "tags-type-column",
        },
        {
          title: this.$t("action"),
          type: "action",
          key: "invoice",
          isVisible: true,
        },
      ],
      options: {
        name: this.$t("frund_table"),
        url: "crm/frunds",
        showHeader: true,
        columns: [],
        filters: [
          {
            title: this.$t("created_date"),
            type: "range-picker",
            key: "date",
            option: ["today", "thisMonth", "last7Days", "thisYear"],
          },
          {
            title: this.$t("lead_group"),
            type: "checkbox",
            key: "contact_type",
            option: [],
          },
          {
            title: this.$t("tag"),
            type: "multi-select-filter",
            key: "tags",
            option: [],
          },
        ],
        showSearch: true,
        showFilter: true,
        paginationType: "pagination",
        responsive: false,
        rowLimit: 50,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
        actions: [
          {
            title: this.$t("quick_view"),
            icon: "zap",
            type: "modal",
            component: "app-frund-quick-view",
            modalId: "quickViewModal",
            url: "",
          },
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "modal",
            component: "app-frund-modal",
            modalId: "frund-modal",
            url: "",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "modal",
            component: "app-confirmation-modal",
            modalId: "frund-delete-modal",
            url: "",
          },
        ],
      },
    };
  },
  methods: {
	  
	getFrundValue() {
      this.axiosGet("crm/frund-value").then((response) => {
        this.options.filters.push({
          title: this.$t("frund_value"),
          type: "range-filter",
          key: "frund-value",
          minTitle: this.$t("minimum_value"),
          maxTitle: this.$t("maximum_value"),
          maxRange: response.data.max_frund_value,
          minRange:
            response.data.min_frund_value < response.data.max_frund_value
              ? response.data.min_frund_value
              : 0,
        });
      });
    },
    getAction(rowData, actionObj, active) {
      if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `crm/frunds/${rowData.id}`;
        this.isFrundModalActive = true;
      } else if (actionObj.title == this.$t("delete")) {
        this.deleteUrl = `crm/frunds/${rowData.id}`;
        this.confirmationModalActive = true;
      } else if (actionObj.title == this.$t("quick_view")) {
        this.selectedUrl = `crm/frund/navigation-change/${rowData.id + 1}?parm=previous`;
        this.isQuickViewModalActive = true;
      }
    },
    openModal() {
      this.isFrundModalActive = true;
    },
    openContactModal() {
      this.isContactModalActive = true;
    },
    closeContactModal() {
      this.isContactModalActive = false;
      this.selectedUrl = "";
      $("#contact-type-modal").modal("hide");
    },
    closeModal() {
      this.isFrundModalActive = false;
      this.selectedUrl = "";
      $("#frund-modal").modal("hide");
    },
    closeQuickViewModal() {
      this.isQuickViewModalActive = false;
      this.selectedUrl = "";
      $("#quickViewModal").modal("hide");
    },
    commonActivityModal(activity) {
      this.editedUrl = `crm/activities/${activity.id}`;
      this.rowData = activity;
      this.frundActivitiesModal = true;
    },
    openViewAllDeal(frundId) {
      this.frundId = frundId;
      this.viewAllDeal = true;
    },
    openViewAllFollower(followerUrl) {
      this.followerUrl = followerUrl;
      this.viewAllFollower = true;
    },
    editNote(activity) {
      this.noteRowData = activity;
      this.isNoteModal = true;
    },
    closeNoteModal() {
      this.isNoteModal = false;
      $("#note-modal").modal("hide");
    },
    closeViewAllModal() {
      this.viewAllDeal = false;
      $("#details-view-modal").modal("hide");
    },
    closedFollowerModal() {
      this.viewAllFollower = false;
      $("#details-view-modal").modal("hide");
    },

    closeActivityModal() {
      this.frundActivitiesModal = false;
      $("#common-activity-modal").modal("hide");
    },
    openOrganizationModal() {
      this.organizationModal = true;
      setTimeout(() => {
        $("#frund-modal").css({
          //"backdrop-filter": "blur(4px)"
          opacity: "0.5",
        });
      });
    },
    closeOrgModal() {
      this.$store.dispatch("getOrganization");
      $("#organization-modal").modal("hide");
      this.organizationModal = false;
      $("#frund-modal").css({
        opacity: "1",
        //"backdrop-filter": "blur(0px)"
      });
    },
  },
  computed: {
    ...mapGetters({
      organizationList: "getOrganization",
    }),
  },
  mounted() {
    this.getCustomFiled("frund");
	  setTimeout(() => {
      // this.$store.dispatch("getOwner"),
      this.getFrundValue();
    }, 1000);
  },
};
</script>
<style>
.link-list {
  white-space: nowrap !important;
  max-width: 180px;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
